import script from "./OverviewView.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewView.vue?vue&type=script&setup=true&lang=js"

import "./OverviewView.vue?vue&type=style&index=0&id=5ffcc73a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ffcc73a"]])

export default __exports__